import React from "react";
import SideMenu from "./common/SideMenu";

import NavHeader from "./common/NavHeader";
import { Switch, Route } from "react-router-dom";
import Dashboard from "./dashboard";
import DirectSponsor from "./directsponsor";
import TeamList from "./teamlist";
import Buypackage from "./buypackage";
import CWallet from "./cwallet";
import TeamSales from "./teamsales";
import KYCBank from "./kycbank";
import Transactions from "./transactions";
import EWallet from "./ewallet";
import Pan from "./pan";
import ChangePassword from "./changepassword";
import Profile from "./profile";
import PaidSummary from "./paidsummary";
import Joiningbonus from "./joiningbonus";
import Activation from "./activation";
import Transfer from "./transfer";
import JoiningbonusDetail from "./joiningbonusdetail";
import Epin from "./epin";
import JoiningInvoice from "./joininginvoice";
import Invoice from "./invoice";
import TransferHistory from "./transferhistory";
import RepurchaseIncome from "./repurchaseincome";
import SponsorTree from "./sponsortree";
import Upgrade from "./upgrade";
import PurchaseHistory from "./Purchasehistory";

class App extends React.Component {
  render() {
    return (
      <div id="root" style={{ background: "#fff" }}>
        <div className="app sidebar-mini" id="app" style={{ color: "#000" }}>
          <div className="page">
            <div className="page-main">
              <SideMenu history={this.props.history} />
              <div className="app-content main-content" style={{ backgroundColor: "#d0d0ce" }}>
                <div className="side-app">
                  <NavHeader history={this.props.history} />
                  <div>
                    <Switch>
                      <Route exact path="/dashboard" component={Dashboard} />
                      <Route path="/home" component={Dashboard} />
                      <Route exact path="/" component={Dashboard} />
                      <Route exact path="/directsponsor" component={DirectSponsor} />
                      <Route exact path="/teamlist" component={TeamList} />
                      <Route exact path="/transfer" component={Transfer} />
                      <Route exact path="/transfer/:pinid/:pinpass" component={Transfer} />
                      <Route exact path="/treeview" component={SponsorTree} />
                      <Route exact path="/treeview/:treeid" component={SponsorTree} />
                      <Route exact path="/activation" component={Activation} />
                      <Route exact path="/activation/:step" component={Activation} />
                      <Route exact path="/invoice" component={Invoice} />
                      <Route exact path="/invoicedetail/:billno" component={JoiningInvoice} />
                      <Route path="/repurchaseincome" component={RepurchaseIncome} />
                      <Route exact path="/buypackage" component={Buypackage} />
                      <Route exact path="/buypackage/:step" component={Buypackage} />
                      <Route exact path="/cwallet" component={CWallet} />
                      <Route exact path="/teamsales" component={TeamSales} />
                      <Route exact path="/epin" component={Epin} />
                      <Route exact path="/paidsummary" component={PaidSummary} />
                      <Route exact path="/joiningbonus" component={Joiningbonus} />
                      <Route exact path="/kyc/bank" component={KYCBank} />
                      <Route exact path="/transactions/:type" component={Transactions} />
                      <Route exact path="/jbonusreport" component={JoiningbonusDetail} />
                      <Route exact path="/jbonusreport/:cdate" component={JoiningbonusDetail} />
                      <Route exact path="/ewallet" component={EWallet} />
                      <Route exact path="/kyc/pan" component={Pan} />
                      <Route exact path="/kyc/aadhar" component={Pan} />
                      <Route exact path="/profile" component={Profile} />
                      <Route exact path="/pintransferhistory" component={TransferHistory} />
                      <Route exact path="/changepassword/:step" component={ChangePassword} />
                      <Route exact path="/purchasehistory" component={PurchaseHistory} />
                      <Route exact path="/upgrade" component={Upgrade} />
                    </Switch>
                  </div>
                </div>
              </div>
            </div>
            <footer className="footer">
              <div className="container">
                <div className="row align-items-center flex-row-reverse">
                  <div className="col-md-12 col-sm-12 text-center">
                    2024 © All rights reserved. Spark Nature Solution
                  </div>
                </div>
              </div>
            </footer>
          </div>
        </div>
      </div>
    );
  }
}

export default App;

